import type { LocalizedText, RestaurantEquipment } from './types';

export interface EquipmentCategory {
  id: string;
  name: LocalizedText;
  labelEligible: boolean;
  temperatureCapable: boolean;
}

export const EQUIPMENT_CATEGORIES: EquipmentCategory[] = [
  { id: 'refrigeration', name: { en: 'Refrigeration', es: 'Refrigeración' }, labelEligible: true, temperatureCapable: true },
  { id: 'freezers', name: { en: 'Freezers', es: 'Congeladores' }, labelEligible: true, temperatureCapable: true },
  { id: 'cooking', name: { en: 'Cooking equipment', es: 'Equipos de cocción' }, labelEligible: true, temperatureCapable: false },
  { id: 'food-preparation', name: { en: 'Food preparation', es: 'Preparación de alimentos' }, labelEligible: true, temperatureCapable: false },
  { id: 'beverage', name: { en: 'Beverage equipment', es: 'Equipos de bebidas' }, labelEligible: true, temperatureCapable: false },
  { id: 'warewashing', name: { en: 'Warewashing', es: 'Lavado de vajilla' }, labelEligible: true, temperatureCapable: false },
  { id: 'ventilation', name: { en: 'Ventilation', es: 'Ventilación' }, labelEligible: true, temperatureCapable: false },
  { id: 'furniture', name: { en: 'Furniture', es: 'Mobiliario' }, labelEligible: true, temperatureCapable: false },
  { id: 'pos-office', name: { en: 'POS and office', es: 'Punto de venta y oficina' }, labelEligible: true, temperatureCapable: false },
  { id: 'storage', name: { en: 'Storage', es: 'Almacenamiento' }, labelEligible: true, temperatureCapable: false },
  { id: 'smallwares', name: { en: 'Tableware and smallwares', es: 'Vajilla, vasos, copas y cubiertos' }, labelEligible: false, temperatureCapable: false },
  { id: 'safety', name: { en: 'Safety equipment', es: 'Equipos de seguridad' }, labelEligible: true, temperatureCapable: false },
  { id: 'other', name: { en: 'Other equipment', es: 'Otros equipos' }, labelEligible: true, temperatureCapable: false },
];

export function equipmentCategory(id?: string | null): EquipmentCategory {
  return EQUIPMENT_CATEGORIES.find((entry) => entry.id === id) || EQUIPMENT_CATEGORIES[EQUIPMENT_CATEGORIES.length - 1];
}

export function equipmentLabelEligible(item: Pick<RestaurantEquipment, 'categoryId' | 'labelEligible' | 'quantity'>): boolean {
  const category = equipmentCategory(item.categoryId);
  return category.id !== 'smallwares' && (item.quantity ?? 1) === 1 && (item.labelEligible ?? category.labelEligible);
}

export function equipmentTemperatureCapable(item: Pick<RestaurantEquipment, 'categoryId' | 'temperatureCapable'>): boolean {
  const category = equipmentCategory(item.categoryId);
  return category.id !== 'smallwares' && (item.temperatureCapable ?? category.temperatureCapable);
}
